

































import {Component, Emit, Inject, Watch} from "vue-property-decorator";
import {Company, DateTime, Person} from "../../modules/models";
import BirthDateInput from "../BirthDateInput.vue";
import Api from "./Api";
import CompanySelector from "../companyselector/CompanySelector.vue";
import UserRequired from "@/components/UserRequired";

@Component({
    components: {
        "at-birthdate": BirthDateInput,
        "at-company-selector": CompanySelector
    }
})
export default class UserEdit extends UserRequired {
    @Inject()
    api!: Api;

    opened = false;

    guid: string | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    birthDate: DateTime | null= null;
    companyName: string | null = null;
    companyOrgnum: number | null = null;
    employedAt: Company | null = null;

    saving = false;

    set companyOrgnumStr(numStr: string) {
        const num = Number(numStr);
        if(num > 0) {
            this.companyOrgnum = num;
        } else {
            this.companyOrgnum = null;
        }
    }
    get companyOrgnumStr() {
        return this.companyOrgnum != null ? String(this.companyOrgnum) : "";
    }

    get invalidEmployedAt() {
        return this.employedAt != null && this.user.person.guid !== this.guid && !this.user.isCompanyAdmin(this.employedAt.orgNum);
    }

    /*
    get employedAt() {
        return this._employedAt;
    }
    set employedAt(c: Company | null) {
        if(c != null && !this.user.isCompanyAdmin(c.orgNum)) {
            this.emitError(new Error("Du kan bare velge firma du selv er administrator for, eller sette det blankt."));
        } else {
            this._employedAt = c;
        }
    }
    */

    open(person: Person, employedAt: Company | null) {
        this.guid = person.guid;
        this.firstName = person.firstName;
        this.lastName = person.lastName;
        this.birthDate = person.birthDate;
        this.companyName = person.companyName;
        this.companyOrgnum = person.companyOrgnum;
        this.employedAt = employedAt;

        this.opened = true;
    }
    close() {
        this.opened = false;
    }

    async save() {
        if(this.guid != null) {
            this.saving = true;
            try {
                await this.api.saveUserEdit(this.guid, this.firstName, this.lastName, this.birthDate, this.employedAt);
                this.emitUserSaved();
            } catch (err) {
                this.emitError(err);
            }
            this.saving = false;
            this.close();
        } else {
            throw new Error("guid missing");
        }
    }

    @Emit("at-user-edit-saved")
    emitUserSaved() {}
}
